var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import React, { useRef, useState } from 'react';
import { useRecoilState } from 'recoil';
import { ButtonKVBase, DefaultModal, InputKVBase } from '@/presentation/components';
import { manageClassesState } from '../atoms';
import { ALL_GRADES } from '@/presentation/constants/class-grades';
import { fromCardinal } from '@/presentation/functions/cardinal';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import Styles from './add-class-modal-styles.scss';
import Select from '../select/select';
const AddClassModal = ({ manageClasses, idClient }) => {
    const [state, setState] = useRecoilState(manageClassesState);
    const formRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const { showCustomError, showCustomSuccess } = useCustomToast({
        containerId: 'ModalUploadTeachers'
    });
    const toggleModalAddClass = (flag) => setState(prev => (Object.assign(Object.assign({}, prev), { isAddClassModalVisible: flag })));
    const handleSubmit = (event) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        event.preventDefault();
        const form = formRef.current;
        const classGrade = (_a = form === null || form === void 0 ? void 0 : form.querySelector('select[name="classGrade"]')) === null || _a === void 0 ? void 0 : _a.value;
        const className = (_b = form === null || form === void 0 ? void 0 : form.querySelector('input[name="className"]')) === null || _b === void 0 ? void 0 : _b.value;
        const assignedTeacher = (_c = form === null || form === void 0 ? void 0 : form.querySelector('select[name="assignedTeacher"]')) === null || _c === void 0 ? void 0 : _c.value;
        console.log("Grade", state);
        setIsLoading(true);
        const data = {
            name: className,
            grades: [fromCardinal(state.classGrade.value)],
            idClient,
            idTeacher: parseInt(state.assignedTeacher.value)
        };
        const res = yield manageClasses.addClass(data);
        setIsLoading(false);
        if (res) {
            setState(prev => (Object.assign(Object.assign({}, prev), { isAddClassModalVisible: false, reloadClasses: !prev.reloadClasses })));
            showCustomSuccess('OK', 'Class created!');
        }
        else {
            showCustomError('Error', 'Something went wrong!');
        }
    });
    return (React.createElement(DefaultModal, { height: "70", hUnit: "vh", width: "80", wUnit: "vw", open: state.isAddClassModalVisible, onClose: () => toggleModalAddClass(false), showClose: true, overlayCustomStyles: { zIndex: 9999 } },
        React.createElement("form", { method: "post", className: Styles.addModalWrap, onSubmit: handleSubmit, ref: formRef },
            React.createElement("h1", null, "Add class"),
            React.createElement("div", { className: Styles.namesWrap },
                React.createElement("div", { className: Styles.inputWrapLeft },
                    React.createElement(Select, { name: "classGrade", label: "CLASS GRADE", required: true, placeholder: 'ie. 3rd', options: ALL_GRADES.map(item => ({
                            value: `${item}`,
                            label: `${item}`
                        })) })),
                React.createElement("div", { className: Styles.inputWrapRight },
                    React.createElement(InputKVBase, { type: 'text', name: 'className', placeholder: 'ie. 3-A', label: 'CLASS NAME', state: state, setState: setState }))),
            React.createElement("div", { className: Styles.emailWrap },
                React.createElement(Select, { name: "assignedTeacher", label: "ASSIGNED TEACHER", placeholder: 'ie. Mrs. Amanda Smith', required: true, options: state.teachers.map(item => ({
                        value: `${item.id}`,
                        label: `${item.firstName} ${item.lastName}`
                    })) })),
            React.createElement("div", { className: Styles.btnWrap },
                React.createElement(ButtonKVBase, { type: "submit", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", loading: isLoading }, "Confirm")))));
};
export default AddClassModal;
